
import { defineComponent } from 'vue'
import { MenuItem } from 'primevue/menuitem'
import OverlayPanel from 'primevue/overlaypanel'
import i18n from './i18n'
import hemisphereService from '@/services/hemisphere.service'
import { useSession } from '@/composables/auth'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'

export default defineComponent({
  emits: ['menubutton-click'],
  props: {
    menuActive: {
      type: Boolean,
      default: false
    },
    hoverMenuActive: Boolean
  },
  setup() {
    let { user, loggedIn, logout } = useSession()
    return {
      user,
      loggedIn,
      logout,
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  data() {
    return {
      appsMenuActive: false,
      licence: {} as any
    }
  },
  computed: {
    userFullName(): string {
      return this.user.first_name + ' ' + this.user.last_name
    },
    userInitial(): string {
      return this.user.first_name.charAt(0) + this.user.last_name.charAt(0)
    },
    userLicense(): string {
      return this.user.company ? this.$t('user-license.pro') : this.$t('user-license.individual')
    },
    subscriptionMenuItems(): MenuItem[] {
      return [
        {
          label: this.$t('menu-label.subscription-title'),
          items: [
            {
              label: this.$t('menu-label.my-subscription'),
              to: '/subscription',
              icon: 'ci-icon-services',
              disabled: true
            },
            {
              label: this.$t('menu-label.my-purchases'),
              to: '/purchases',
              icon: 'ci-icon-shop',
              disabled: true
            }
          ]
        }
      ]
    },
    buildingMenuItems(): MenuItem[] {
      return [
        {
          label: this.$t('menu-label.building-title'),
          items: [
            {
              label: this.$t('menu-label.building-info'),
              to: '/building-informations',
              icon: 'ci-icon-objects'
            },
            {
              label: this.$t('menu-label.furnitures'),
              to: '/furnitures',
              icon: 'ci-icon-layers'
            },
            {
              label: this.$t('menu-label.zones'),
              to: '/zones',
              icon: 'ci-icon-layers',
              disabled: true
            },
            {
              label: this.$t('menu-label.3dmodel'),
              to: '/modeling',
              icon: 'ci-icon-layers',
              disabled: true
            }
          ]
        }
      ]
    },
    rightsMenuItems(): MenuItem[] {
      return [
        {
          label: this.$t('menu-label.rights-management-title'),
          items: [
            {
              label: this.$t('menu-label.sharing'),
              to: '/sharing',
              icon: 'ci-icon-layers'
            },
            {
              label: this.$t('menu-label.transfert'),
              to: '/transfert',
              icon: 'ci-action-export',
              disabled: true
            }
          ]
        }
      ]
    },
    currentLicenceName() {
      if (this.licence?.category_label == 'FLEXOM') {
        return 'Offre Flexom'
      }
      return this.$t('offer-plan.freemium')
    },
    appListItem() {
      return [
        {
          label: this.$t('mosaic-apps.account'),
          secondaryLabel: this.$t('offer-plan.freemium'),
          url: process.env.VUE_APP_PLATFORM_ACCOUNT_URL + '/home'
        },
        {
          label: this.$t('mosaic-apps.shop'),
          secondaryLabel: this.$t('offer-plan.freemium'),
          url: process.env.VUE_APP_PLATFORM_SHOP_URL
        },
        {
          label: 'Flexhorizon',
          url: process.env.VUE_APP_FLEX_HORIZON_URL,
          secondaryLabel: this.$t('offer-plan.freemium')
        },
        {
          label: 'Application Ubiant',
          secondaryLabel: this.$t('offer-plan.freemium'),
          url: process.env.VUE_APP_APP_WEBGL_URL
        },
        {
          label: 'Ubiant 3D',
          secondaryLabel: this.$t('offer-plan.unavailable'),
          url: process.env.VUE_APP_PLATFORM_MAP_URL,
          disabled: true
        },
        {
          label: 'Designer',
          url: process.env.VUE_APP_DESIGNER_URL,
          secondaryLabel: this.$t('offer-plan.unavailable'),
          locked: true,
          disabled: true
        }
      ]
    }
  },
  methods: {
    log(event: Event) {
      this.logout()
    },
    logText(): string {
      if (this.loggedIn) {
        return this.$t('commons.logout')
      } else {
        return this.$t('menu-label.login')
      }
    },
    onMenuButtonClick(event: Event) {
      this.$emit('menubutton-click', event)
    },
    onAppsButtonClick(event: Event) {
      this.appsMenuActive = !this.appsMenuActive
      ;(this.$refs.op as OverlayPanel).toggle(event)
    },
    onLanguageMenuClick(event: Event) {
      ;(this.$refs.languageMenu as OverlayPanel).toggle(event)
    },
    selectLanguage(event: Event, locale: string) {
      i18n.global.locale = locale
      ;(this.$refs.languageMenu as OverlayPanel).toggle(event)
    }
  },
  async mounted() {
    if (this.loggedIn) {
      const buildingId = await this.getCurrentBuildingId()
      if (buildingId) {
        const resp = await hemisphereService.getBuilding(buildingId)
        this.licence = resp.data.building?.licence
      }
    }
  }
})
